import { createContext, useContext, useRef } from 'react'
import { useRadioGroup, useRadio } from '@react-aria/radio'
import { useRadioGroupState } from '@react-stately/radio'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useFocusRing } from '@react-aria/focus'
import { useTheme } from 'styled-components'

// RadioGroup is the same as in the previous example
const RadioContext = createContext(null)

export function RadioGroup(props) {
  const { children, label } = props
  const state = useRadioGroupState(props)
  const { radioGroupProps, labelProps } = useRadioGroup(props, state)

  return (
    <div {...radioGroupProps} className="ul-flex">
      {label ? <span {...labelProps}>{label}</span> : null}
      <RadioContext.Provider value={state}>{children}</RadioContext.Provider>
    </div>
  )
}

export function Radio(props) {
  const theme = useTheme()
  const { children } = props
  const state = useContext(RadioContext)
  const ref = useRef(null)
  const { inputProps } = useRadio(props, state, ref)
  const { isFocusVisible, focusProps } = useFocusRing()

  const isSelected = props.selected
  const strokeWidth = isSelected ? 6 : 2

  return (
    <label
      className={'ul-flex ul-items-center ul-mr-10 ' + props.className}
      onClick={props.onClick}
    >
      <VisuallyHidden>
        <input {...inputProps} {...focusProps} ref={ref} />
      </VisuallyHidden>
      <svg width={24} height={24} aria-hidden="true" style={{ marginRight: 4 }}>
        <circle
          cx={12}
          cy={12}
          r={8 - strokeWidth / 2}
          fill="none"
          stroke={isSelected ? theme.mainColor : 'gray'}
          strokeWidth={strokeWidth}
        />
        {isFocusVisible && (
          <circle
            cx={12}
            cy={12}
            r={11}
            fill="none"
            stroke={theme.mainColor}
            strokeWidth={2}
          />
        )}
      </svg>
      {children}
    </label>
  )
}
